import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function DefaultDropzoneContent() {
  const { t } = useTranslation();

  return (
    <Text fontSize="12px" fontWeight={400} color="baseBlack">
      {t('global.dropzone.defaultContent')}
    </Text>
  );
}
